import { useCallback, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';
import { getPatientMonthlyLimit } from '../service';
import CustomMonthDatePicker from '../components/CustomMonthDatePicker';
import moment from 'moment';
import { Table } from '../components/Table';
import {
  ColumnData,
  MonthlyLimitResult,
  OrderTypeProps,
} from '../interface/interface';

export default function PatientMonthlyLimit() {
  const { patientId } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [monthRange, setMonthRange] = useState<[Date | null, Date | null]>(
    () => {
      const currentDate = new Date();
      const toDate = new Date(currentDate);
      const fromDate = new Date(currentDate);
      fromDate.setMonth(currentDate.getMonth() - 3);

      return [fromDate, toDate];
    },
  );
  const [monthlyLimitMonthWise, setMonthlyLimitMonthWise] = useState<
    Array<MonthlyLimitResult | []>
  >([]);

  useEffect(() => {
    if (!user?.access_token || !patientId) {
      console.warn('User access Token or Patient id not found');
      return;
    }

    setLoading(true);

    if (!monthRange[0] || !monthRange[1]) {
      return;
    }

    getPatientMonthlyLimit(
      user.access_token,
      patientId,
      moment(monthRange[0]).format('DD-MM-YYYY'),
      moment(monthRange[1]).format('DD-MM-YYYY'),
    )
      .then((data) => {
        const sortedData = [...data]?.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        );
        setMonthlyLimitMonthWise(sortedData);
      })
      .catch((err) => {
        console.error(err);
        setMonthlyLimitMonthWise([]);
      });

    setLoading(false);
  }, [user?.access_token, monthRange]);

  const handleDateRangeChange = useCallback(
    (range: [Date | null, Date | null]) => {
      setMonthRange(range);
    },
    [setMonthRange],
  );

  const columns: Array<ColumnData> = [
    {
      key: 'date',
      header: () => 'Month',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
    {
      key: 'sum',
      header: () => 'Consumed Flower Limit',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
    {
      key: 'vape_sum',
      header: () => 'Consumed Vape Cart Limit',
      isSortable: true,
      cell: (info) => info.getValue(),
    },
  ];

  return (
    <>
      <div className="flex justify-end mb-10 cursor-pointer">
        <CustomMonthDatePicker
          monthRange={monthRange}
          onMonthChange={handleDateRangeChange}
          restrict={12}
        />
      </div>

      {monthlyLimitMonthWise.length ? (
        <Table
          columns={columns}
          data={monthlyLimitMonthWise}
          childLoader={loading}
          order={OrderTypeProps.DOCTOR}
        />
      ) : (
        <p className="font-semibold text-primary-blue-500 text-center text-xl">
          Records Not Found
        </p>
      )}
    </>
  );
}
